export default {
  products: 1,
  news: 1,
  policies: 1,
  trees: 2
};
